import { PharmacyStatusEnum } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { entityRegistry } from '@app/icare/entities/registry'
import { Trans } from '@lingui/react/macro'
import { createQueryStore, QueryBaseSchema } from '@pkg/api/query'
import { EntityIndexPage } from '@pkg/ui/layout/EntityIndexPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/apotheken/')({
  component: RouteComponent,
})
const { search } = entityRegistry.pharmacy

const filter = createQueryStore({
  schema: search.filterSchema ?? QueryBaseSchema,
})

function RouteComponent() {
  return (
    <EntityIndexPage
      queryStore={filter}
      filter={[
        {
          name: 'status',
          mode: 'multiple',
          label: <Trans>Status der Apotheke</Trans>,
          options: PharmacyStatusEnum.$.options,
        },
      ]}
      entityName="pharmacy"
    />
  )
}
